import { Box, Paper, Stack, Table, TableBody, TableContainer, TableHead, Typography } from '@mui/material';
import { BorderWrapper, Cell, HeaderText, RowText, StyledTableHead, StyledTableRow } from '@styles/CommonStyles';
import { formatCurrency } from '@shared/commonFunctions';
import { IPublicRecordsProps } from './interfaces/interfaces';


export const PUBLIC_RECORDS_HEADERS = [
  'Court Name/Number\nRecord Type\nCourt Type\nPublic Record Disposition',
  'Date Reported\nDate Paid\nACC Designator\nDocket',
  'Member Number\nPlaintiff\nAttorney\nIndustry',
  'Amount\nAssets\nLiability\nOrig. Date',
];

const renderPublicRecordsHeader = () => (
  <TableHead>
    <StyledTableHead>
      <Cell>
        <Stack>
          <HeaderText>Court Name/Number</HeaderText>
          <HeaderText>Record Type</HeaderText>
          <HeaderText>Court Type</HeaderText>
          <HeaderText>Public Record Disposition</HeaderText>
        </Stack>
      </Cell>
      <Cell>
        <Stack>
          <HeaderText>Date Reported</HeaderText>
          <HeaderText>Date Paid</HeaderText>
          <HeaderText>ACC Designator</HeaderText>
          <HeaderText>Docket</HeaderText>
        </Stack>
      </Cell>
      <Cell>
        <Stack>
          <HeaderText>Member Number</HeaderText>
          <HeaderText>Plaintiff</HeaderText>
          <HeaderText>Attorney</HeaderText>
          <HeaderText>Industry</HeaderText>
        </Stack>
      </Cell>
      <Cell>
        <Stack>
          <HeaderText>Amount</HeaderText>
          <HeaderText>Assets</HeaderText>
          <HeaderText>Liability</HeaderText>
          <HeaderText>Orig. Date</HeaderText>
        </Stack>
      </Cell>
    </StyledTableHead>
  </TableHead>
);

const renderPublicRecordsRows = ({ publicRecords }: IPublicRecordsProps) => (
  <TableBody>
    {publicRecords?.map((data, index) => (
      <StyledTableRow
        key={data?.referenceNumber}
        index={index}
      >
        <Cell>
          <Stack
            direction="column"
            gap={1}
          >
            <RowText fontWeight="bold !important">{`${data.court ? `${data.court}/` : ''}  ${data.courtCode}`}</RowText>
            <RowText>{data?.recordType ?? ''}</RowText>
            <RowText>{data?.courtType ?? ''}</RowText>
            <RowText>&#xA0;</RowText>
          </Stack>
        </Cell>
        <Cell>
          <Stack
            direction="column"
            minWidth="80px"
            gap={1}
          >
            <RowText>{data?.statusDate ?? ''}</RowText>
            <RowText>{data?.statusDate ?? ''}</RowText>
            <RowText>{data?.accDesignator ?? ''}</RowText>
            <RowText>{data?.docket ?? ''}</RowText>
          </Stack>
        </Cell>
        <Cell>
          <Stack
            direction="column"
            gap={1}
          >
            <RowText>{data?.referenceNumber ?? ''}</RowText>
            <RowText>{data?.platiffName ?? ''}</RowText>
            <RowText>&#xA0;</RowText>
            <RowText>&#xA0;</RowText>
          </Stack>
        </Cell>
        <Cell>
          <Stack
            direction="column"
            gap={1}
          >
            <RowText>{data?.amount ? formatCurrency(data.amount) : ''}</RowText>
            <RowText>{data?.assetAmount ? formatCurrency(data.assetAmount) : ''}</RowText>
            <RowText>{data?.liabilityAmount ? formatCurrency(data.liabilityAmount) : ''}</RowText>
            <RowText>{data?.originalDate ?? ''}</RowText>
          </Stack>
        </Cell>
      </StyledTableRow>
    ))}
  </TableBody>
);

export const PublicRecords = ({ publicRecords }: IPublicRecordsProps) => (
  <Box marginBottom={2}>
    <Typography
      fontWeight={600}
      variant="h3"
    >
      Public Records
    </Typography>
    <BorderWrapper>
      <TableContainer component={Paper}>
        <Table>
          {renderPublicRecordsHeader()}
          {renderPublicRecordsRows({ publicRecords })}
        </Table>
      </TableContainer>
    </BorderWrapper>
  </Box>
);
